import {
  Top5Page,
  PursuitsPage,
  ImGoodAtPage,
  DidYouKnowPage,
  MoreAboutMePage,
  BasicsPage,
  SnapshotPage,
  MediaPage
} from '../../smart-components'

export enum MENU_IDS {
  SNAPSHOT = 'snapshot',
  BASICS = 'the-basics',
  TOP_FIVES = 'top-fives',
  DID_YOU_KNOW = 'did-you-know',
  I_PURSUE_WITH_INTENSITY = 'pursuits',
  IM_GOOD_AT = 'im-good-at',
  MORE_ABOUT_ME = 'more-about-me',
  MEDIA = 'media',
  INITIATIVES = 'initiatives'
}

export const MENU_LIST = [
  {
    id: MENU_IDS.SNAPSHOT,
    title: 'Snapshot',
    path: '/snapshot',
    component: SnapshotPage,
    visibleOnMobile: true
  },
  {
    id: MENU_IDS.TOP_FIVES,
    title: 'Top 5s',
    path: '/top-fives',
    component: Top5Page,
    visibleOnMobile: true,
    validation: 'isTop5SComplete',
    validationFields: ['selfTag', 'teamMembersSay', 'thriveEnv']
  },
  {
    id: MENU_IDS.DID_YOU_KNOW,
    title: 'Did you know',
    path: '/did-you-know',
    component: DidYouKnowPage,
    visibleOnMobile: true,
    validation: 'isDidYouKnowSemiComplete',
    validationFields: ['statNum', 'statDetail', 'funFact', 'randomJob', 'uniqueInterest', 'tedTalk', 'projectToLife']
  },
  {
    id: MENU_IDS.BASICS,
    title: 'The basics',
    path: '/the-basics',
    component: BasicsPage,
    visibleOnMobile: true,
    validationFields: [
      'avatar',
      'firstName',
      'lastName',
      'currentRole',
      'currentCompany',
      'schools',
      'hometownLocation'
    ]
  },
  {
    id: MENU_IDS.I_PURSUE_WITH_INTENSITY,
    title: 'I pursue with intensity',
    path: '/pursuits',
    component: PursuitsPage,
    visibleOnMobile: true,
    validationFields: ['passions']
  },
  {
    id: MENU_IDS.IM_GOOD_AT,
    title: "I'm good at",
    path: '/im-good-at',
    component: ImGoodAtPage,
    visibleOnMobile: true,
    validationFields: ['expertise', 'becomeExpertIn']
  },
  {
    id: MENU_IDS.MORE_ABOUT_ME,
    title: 'More about me',
    path: '/more-about-me',
    component: MoreAboutMePage,
    visibleOnMobile: true,
    validationFields: ['impactOn', 'impactGoodAt', 'impactInterested', 'toGetMeTalking', 'inDealingWithPeople']
  },
  {
    id: MENU_IDS.MEDIA,
    title: 'Media',
    path: '/media',
    component: MediaPage,
    visibleOnMobile: true
  },
  {
    id: MENU_IDS.INITIATIVES,
    title: 'Initiatives',
    visibleOnMobile: true
  }
]
